import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { IfPermitted, LinkContainer } from "components/common";
import Routes from "routing/Routes";
import HideOnCloud from "util/conditional/HideOnCloud";
const extractorsLink = (input) => input.global || !input.node ? Routes.global_input_extractors(input.id) : Routes.local_input_extractors(input.node, input.id);
const ExtractorsSectionActions = ({ input }) => {
  const { t } = useTranslation("inputs");
  return /* @__PURE__ */ React.createElement(HideOnCloud, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`inputs:edit:${input.id}`, `input_types:create:${input.type}`] }, /* @__PURE__ */ React.createElement(LinkContainer, { to: extractorsLink(input) }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", bsSize: "xsmall" }, t("overview.sections.manage_extractors")))));
};
export default ExtractorsSectionActions;
